import { render, staticRenderFns } from "./Mentores.vue?vue&type=template&id=24c3baad&"
import script from "./Mentores.vue?vue&type=script&lang=js&"
export * from "./Mentores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports